import slice from './workspaceSlice';

export * from './types';

import { MAX_ANALYSES_PER_ROW } from './workspaceSlice';
export const {
  populateWorkspace,
  clearWorkspace,
  renameWorkspace,
  workspaceEditActivate,
  workspaceEditSave,
  workspaceEditCancel,
  workspaceDragSetSelected,
  workspaceDragStart,
  workspaceDragUpdate,
  workspaceDragEnd,
} = slice.actions;
export { MAX_ANALYSES_PER_ROW };
export default slice.reducer;
